import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IRoleGroupInitialState} from "../types";
import {GetDeleteRoleGroups, GetRoleGroups} from "./thunk";

const initialState:IRoleGroupInitialState = {
    roleGroups:[],
    roleGroupsRestore:[],
    selectedRoleGroupsIDs:[],
    isLoadingRolesGroups:false,
    isViewRoleGroupsRestore:false,
}

const roleGroupsSlice = createSlice({
    name:"roleGroups",
    initialState,
    reducers:{
        setRoleGroups: (state, action) => {
            state.roleGroups = action.payload;
        },
        setRoleGroupsRestore: (state, action) => {
            state.roleGroupsRestore = action.payload;
        },
        setIsViewRoleGroupsRestore: (state) => {

            state.isViewRoleGroupsRestore = !state.isViewRoleGroupsRestore;
        },
        deletedRoleGroups: (state, action: PayloadAction<number>) => {
            state.roleGroups = state.roleGroups.filter(
                (elem) => elem.id !== action.payload
            );
        },
        deletedRestoreRoleGroup: (state, action) => {
            state.roleGroupsRestore  = state.roleGroupsRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedRoleGroupIDs: (state, action) => {
            state.selectedRoleGroupsIDs = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetRoleGroups.pending, (state) => {
                state.isLoadingRolesGroups = true;
            })
            .addCase(GetRoleGroups.fulfilled, (state) => {
                state.isLoadingRolesGroups = false;
            })
            .addCase(GetRoleGroups.rejected, (state) => {
                state.isLoadingRolesGroups = false;
            })
            .addCase(GetDeleteRoleGroups.pending, (state) => {
                state.isLoadingRolesGroups = true;
            })
            .addCase(GetDeleteRoleGroups.fulfilled, (state) => {
                state.isLoadingRolesGroups = false;
            })
            .addCase(GetDeleteRoleGroups.rejected, (state) => {
                state.isLoadingRolesGroups = false;
            })
    }
})

export const{
    setRoleGroups,
    setRoleGroupsRestore,
    setIsViewRoleGroupsRestore,
    deletedRoleGroups,
    deletedRestoreRoleGroup,
    setSelectedRoleGroupIDs
}=roleGroupsSlice.actions

export default roleGroupsSlice